/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CommitServerIdentityConfigurationForm,
  CommitServerIdentityConfigurationForm$Outbound,
  CommitServerIdentityConfigurationForm$outboundSchema,
} from "../components/commitserveridentityconfigurationform.js";

export type CommitServerIdentityConfigurationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CommitServerIdentityConfigurationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CommitServerIdentityConfigurationSecurity = {
  option1?: CommitServerIdentityConfigurationSecurityOption1 | undefined;
  option2?: CommitServerIdentityConfigurationSecurityOption2 | undefined;
};

export type CommitServerIdentityConfigurationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  commitServerIdentityConfigurationForm: CommitServerIdentityConfigurationForm;
};

/** @internal */
export type CommitServerIdentityConfigurationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CommitServerIdentityConfigurationSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CommitServerIdentityConfigurationSecurityOption1$Outbound,
    CommitServerIdentityConfigurationSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function commitServerIdentityConfigurationSecurityOption1ToJSON(
  commitServerIdentityConfigurationSecurityOption1:
    CommitServerIdentityConfigurationSecurityOption1,
): string {
  return JSON.stringify(
    CommitServerIdentityConfigurationSecurityOption1$outboundSchema.parse(
      commitServerIdentityConfigurationSecurityOption1,
    ),
  );
}

/** @internal */
export type CommitServerIdentityConfigurationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CommitServerIdentityConfigurationSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CommitServerIdentityConfigurationSecurityOption2$Outbound,
    CommitServerIdentityConfigurationSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function commitServerIdentityConfigurationSecurityOption2ToJSON(
  commitServerIdentityConfigurationSecurityOption2:
    CommitServerIdentityConfigurationSecurityOption2,
): string {
  return JSON.stringify(
    CommitServerIdentityConfigurationSecurityOption2$outboundSchema.parse(
      commitServerIdentityConfigurationSecurityOption2,
    ),
  );
}

/** @internal */
export type CommitServerIdentityConfigurationSecurity$Outbound = {
  Option1?:
    | CommitServerIdentityConfigurationSecurityOption1$Outbound
    | undefined;
  Option2?:
    | CommitServerIdentityConfigurationSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const CommitServerIdentityConfigurationSecurity$outboundSchema:
  z.ZodMiniType<
    CommitServerIdentityConfigurationSecurity$Outbound,
    CommitServerIdentityConfigurationSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        CommitServerIdentityConfigurationSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        CommitServerIdentityConfigurationSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function commitServerIdentityConfigurationSecurityToJSON(
  commitServerIdentityConfigurationSecurity:
    CommitServerIdentityConfigurationSecurity,
): string {
  return JSON.stringify(
    CommitServerIdentityConfigurationSecurity$outboundSchema.parse(
      commitServerIdentityConfigurationSecurity,
    ),
  );
}

/** @internal */
export type CommitServerIdentityConfigurationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CommitServerIdentityConfigurationForm:
    CommitServerIdentityConfigurationForm$Outbound;
};

/** @internal */
export const CommitServerIdentityConfigurationRequest$outboundSchema:
  z.ZodMiniType<
    CommitServerIdentityConfigurationRequest$Outbound,
    CommitServerIdentityConfigurationRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      commitServerIdentityConfigurationForm:
        CommitServerIdentityConfigurationForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        commitServerIdentityConfigurationForm:
          "CommitServerIdentityConfigurationForm",
      });
    }),
  );

export function commitServerIdentityConfigurationRequestToJSON(
  commitServerIdentityConfigurationRequest:
    CommitServerIdentityConfigurationRequest,
): string {
  return JSON.stringify(
    CommitServerIdentityConfigurationRequest$outboundSchema.parse(
      commitServerIdentityConfigurationRequest,
    ),
  );
}
